import { define } from '../../define.js';
import { ColorSchemeIcon } from './color-scheme-icon.js';
export * from './color-scheme-icon.js';
define('color-scheme-icon', ColorSchemeIcon);
